<template>
  <div class="pt-8 parent-container-404">
    <div class="container-404" :class="mobile ? 'px-5 pt-15' : 'px-15'">
      <div
        class="mb-5"
        :class="mobile ? 'px-5' : 'px-15'"
        style="width:100%; display: flex; flex-direction: row; align-items: center;"
        :style="
          desktop ? 'justify-content: flex-start;' : 'justify-content: center;'
        "
      >
        <div>
          <v-img
            :src="require('@/assets/images/logo/logo-white.svg')"
            contain
            max-height="100"
          />
        </div>
      </div>
      <div
        v-if="mobile && !formCheck"
        class="mb-5"
        :class="mobile ? 'px-5' : 'px-15'"
        style="width:100%; display: flex; flex-direction: row; align-items: center;"
        :style="
          desktop ? 'justify-content: flex-start;' : 'justify-content: center;'
        "
      >
        <div>
          <v-img
            v-if="!sent"
            :src="require('@/assets/images/logo/clientes.svg')"
            contain
            max-height="150"
          />
          <v-img
            v-if="sent"
            :src="require('@/assets/images/logo/emailsent.svg')"
            contain
            max-height="150"
          />
        </div>
      </div>
      <div
        v-if="!formCheck"
        class="mb-5"
        :class="mobile ? 'px-5' : 'px-15'"
        style="width:100%; display: flex; flex-direction: row; align-items: center;"
        :style="
          desktop ? 'justify-content: flex-start;' : 'justify-content: center;'
        "
      >
        <div>
          <span
            v-if="!sent"
            class="my-4"
            :class="mobile ? 'title-404-mobile' : 'title-404'"
            >¿Buscas acelerar la Transformación Digital de tu empresa?</span
          >
          <span
            v-if="sent"
            class="my-4"
            :class="mobile ? 'title-404-mobile' : 'title-404'"
            >¡Estamos en contacto!</span
          >
        </div>
      </div>
      <div
        v-if="!formCheck"
        style="width: 100%; display: flex; flex-direction: row;"
      >
        <div
          :style="mobile ? 'width: 100%;' : 'width: 50%'"
          :class="mobile ? '' : 'mt-3'"
        >
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <div v-if="desktop">
              <span
                v-if="!sent"
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Tway te conecta con
                <strong>proveedores especializados</strong> y a la
                <strong>medida</strong> de las <strong>necesidades</strong> de
                tu organización, te entrega el
                <strong>Índice de Madurez Digital Tway</strong>,
                <strong>acompaña y mide</strong> los resultados del proceso en
                tu negocio.</span
              >
              <span
                v-if="sent"
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Conoce más de lo que la Transformación Digital puede hacer por
                tu empresa visitando nuestra web.</span
              >
            </div>
            <div v-if="mobile">
              <span
                v-if="!sent"
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Tway te conecta con proveedores especializados y a la medida de
                las necesidades de tu organización, te entrega el Índice de
                Madurez Digital Tway, acompaña y mide los resultados del proceso
                en tu negocio.</span
              >
              <span
                v-if="sent"
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Conoce más de lo que la Transformación Digital puede hacer por
                tu empresa visitando nuestra web.</span
              >
            </div>
          </div>
          <div
            v-if="!sent"
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <div v-if="desktop">
              <span
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Y todo desde un marketplace
                <strong>inteligente, sencillo y ágil.</strong></span
              >
            </div>
            <div v-if="mobile">
              <span
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Y todo desde un marketplace inteligente, sencillo y ágil.</span
              >
            </div>
          </div>
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15 mt-13'"
            style="width:100%; display: flex; align-items: center;"
            :style="
              desktop
                ? 'flex-direction: row; justify-content: flex-start;'
                : 'flex-direction: column; justify-content: center;'
            "
          >
            <v-btn
              v-if="!sent"
              rounded
              x-large
              class="white--text"
              style="background-color: #16C62E"
              :class="desktop ? 'mr-5' : 'mb-5'"
              @click="
                () => {
                  formCheck = true;
                }
              "
            >
              Quiero más información
            </v-btn>
            <v-btn
              v-if="!sent"
              rounded
              x-large
              class="white--text"
              style="background-color: #16C62E"
              @click="
                () => {
                  formCheck = true;
                }
              "
            >
              Quiero una demo gratis
            </v-btn>
            <v-btn
              v-if="sent"
              rounded
              x-large
              class="white--text"
              style="background-color: #16C62E"
              to="/"
            >
              ¡vamos!
            </v-btn>
          </div>
        </div>
        <div v-if="desktop" :style="mobile ? 'width: 100%;' : 'width: 50%'">
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop ? 'justify-content: center;' : 'justify-content: center;'
            "
          >
            <div>
              <v-img
                v-if="!sent"
                :src="require('@/assets/images/logo/clientes.svg')"
                contain
                max-height="350"
              />
              <v-img
                v-if="sent"
                :src="require('@/assets/images/logo/emailsent.svg')"
                contain
                max-height="350"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="formCheck"
        style="width: 100%; display: flex;"
        :style="desktop ? 'flex-direction: row;' : 'flex-direction: column;'"
      >
        <div
          :style="mobile ? 'width: 100%;' : 'width: 50%'"
          :class="mobile ? '' : 'mt-3'"
        >
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <div>
              <span
                class="my-4"
                :class="mobile ? 'title-404-mobile' : 'title-404'"
                >Busco acelerar la Transformación Digital de mi empresa</span
              >
            </div>
          </div>
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <div>
              <span
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
                >Nuestro equipo Tway se contactará y con gusto responderemos tus
                preguntas y te ayudaremos.</span
              >
            </div>
          </div>
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <ul>
              <li
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
              >
                <p v-if="mobile" style="color: white;">&bull;</p>
                Descubre cómo impulsar la Transformación Digital de tu negocio
              </li>
              <li
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
              >
                <p v-if="mobile" style="color: white;">&bull;</p>
                Infórmate sobre cómo comenzar y con qué proveedor hacerlo
              </li>
              <li
                class="my-4"
                :class="mobile ? 'subtitle-404-mobile' : 'subtitle-404'"
              >
                <p v-if="mobile" style="color: white;">&bull;</p>
                Explora casos de uso de tu sector
              </li>
            </ul>
          </div>
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop
                ? 'justify-content: flex-start;'
                : 'justify-content: center;'
            "
          >
            <v-btn
              rounded
              x-large
              class="white--text"
              outlined
              :class="desktop ? 'mr-5' : 'mb-5'"
              @click="() => (formCheck = false)"
            >
              Volver
            </v-btn>
          </div>
        </div>
        <div :style="mobile ? 'width: 100%;' : 'width: 50%'">
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15'"
            style="width:100%; display: flex; flex-direction: row; align-items: center;"
            :style="
              desktop ? 'justify-content: center;' : 'justify-content: center;'
            "
          >
            <div>
              <span
                class="my-4"
                :class="mobile ? 'title-404-mobile' : 'title-404'"
                >Contacto</span
              >
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="width: 50%" class="pr-1">
              <v-text-field
                color="white"
                label="Nombre"
                dark
                v-model="form.name"
              ></v-text-field>
            </div>
            <div style="width: 50%" class="pl-1">
              <v-text-field
                color="white"
                label="Apellido"
                dark
                v-model="form.lastname"
              ></v-text-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <v-text-field
                color="white"
                label="Empresa"
                dark
                v-model="form.company"
              ></v-text-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <v-text-field
                color="white"
                label="Sector"
                dark
                v-model="form.sector"
              ></v-text-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <v-text-field
                color="white"
                :rules="emailRules"
                class="app-combobox"
                label="Correo corporativo"
                dark
                v-model="form.email"
              ></v-text-field>
            </div>
          </div>
          <div style="display: flex; flex-direction: column;">
            <div style="width: 100%">
              <v-text-field
                color="white"
                label="Número de contacto"
                :rules="phoneRules"
                dark
                v-model="form.phone"
              ></v-text-field>
            </div>
            <div v-if="phoneCheck" style="width: 100%">
              <span style="color: #cccccc;">Ej: +56912345678</span>
            </div>
          </div>
          <div style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <v-checkbox color="success" dark v-model="check">
                <template v-slot:label>
                  <div>
                    <a
                      @click.stop="modalTerms = true"
                      target="_blank"
                      class="white--text text-decoration-underline"
                    >
                      Acepto ser contactado por Tway SpA* Términos y condiciones
                      generales de uso de datos
                    </a>
                  </div>
                </template>
              </v-checkbox>
              <v-dialog
                class="modal-dialog modal-sm"
                v-model="modalTerms"
                :max-width="desktop ? '714' : '343'"
              >
                <v-card>
                  <div class="text-h6 ml- pa-5">
                    Autorización Tratamiento Datos Personales
                  </div>
                  <v-card-text class="scrollable">
                    <p>
                      En cumplimiento de la Ley 19.628 sobre Protección de la
                      Vida Privada y sus modificaciones, declaro haber sido
                      informado sobre el uso que se dará a mis datos personales
                      por parte de Tway SpA, sus empresas relacionadas,
                      concesionarios autorizados, terceros intermediarios,
                      entidades financieras, corredoras y compañías de seguros,
                      todo relacionado a una operación automotriz, y siempre que
                      fuere necesario, así como con aquellos terceros a los
                      cuales Tway encargue el tratamiento de datos personales
                      (Responsable) para que recolecten, traten y almacenen mis
                      datos bajo las siguientes finalidades:
                    </p>
                    <p>
                      (i) enviar información; (ii) tramitar mi solicitud de
                      demostración gratis del producto (incluyendo envío de
                      correspondencia); (iii) ejecutar y cumplir los contratos
                      que celebremos, incluyendo envío de facturas al correo
                      electrónico, gestiones de cobranza e información a DICOM;
                      (iv) informar a las autoridades competentes la presunción
                      de fraudes, lavado de activos o la financiación del
                      terrorismo; (v) elaborar estudios, encuestas, análisis de
                      tendencias de mercado y en general cualquier estudio
                      técnico o de campo (vi) enviar ofertas de sus productos
                      y/o servicios, o comunicaciones comerciales de cualquier
                      clase relacionadas con los mismos; (vii) crear bases de
                      datos de acuerdo a las características y perfiles de los
                      titulares de Datos Personales; (viii) elaborar encuestas
                      de satisfacción; (ix) elaborar reportes de campañas de
                      servicios; (x) gestionar y hacer seguimiento de consultas
                      y reclamos.
                    </p>
                    <p>
                      Los Responsables del tratamiento podrán tratar y conservar
                      mis datos personales mientras sea necesario para el
                      cumplimiento de las finalidades señaladas. Asimismo,
                      declaro que he sido informado sobre la Política de
                      Privacidad de Tway SpA, la que ha sido puesta a mi
                      disposición en https://www.tway.cl/cliente , para
                      conocimiento. He sido informado asimismo que tengo el
                      derecho a conocer, actualizar, rectificar, suprimir,
                      revocar, oponerme, requerir la portabilidad de mis datos y
                      solicitar prueba: i) de autorización y ii) de finalidad de
                      tratamiento.
                    </p>
                    <p>
                      Adicionalmente, declaro haber sido informado que cualquier
                      reclamo sobre la materia es a través de los canales de
                      atención contacto@tway.cl o ante el responsable de datos
                      de Derco al mail datos@derco.cl. En consecuencia, autorizo
                      expresamente a Tway SpA y /o a los Responsables, para que
                      efectúen el tratamiento de mis datos personales conforme
                      lo expuesto. Declaro asimismo la veracidad de los datos
                      acá informados.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row justify="center" class="ma-0 pa-0">
                      <a
                        class="tway-violet--text ma-2 pa-2 pr-15 roboto"
                        v-if="desktop"
                        @click.stop="modalTerms = false"
                      >
                        VOLVER
                      </a>
                      <v-btn
                        v-if="desktop"
                        large
                        rounded
                        color="tway-morado"
                        class="white--text ma-2 roboto"
                        @click.stop="modalTerms = false"
                      >
                        ACEPTAR
                      </v-btn>
                    </v-row>
                    <v-row v-if="!desktop" justify="center">
                      <v-row justify="center" class="ma-0 pa-0">
                        <a
                          class="tway-violet--text pa-3 pr-5 roboto"
                          @click.stop="modalTerms = false"
                        >
                          VOLVER
                        </a>
                        <v-btn
                          x-large
                          rounded
                          color="tway-violet"
                          class="white--text roboto"
                          @click.stop="modalTerms = false"
                        >
                          ACEPTAR
                        </v-btn>
                      </v-row>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
          <div v-if="error" style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <strong style="color: white;"
                >El Correo ingresado ya está registrado</strong
              >
            </div>
          </div>
          <div v-if="errorForm" style="display: flex; flex-direction: row;">
            <div style="width: 100%">
              <strong style="color: white;"
                >Completa los datos faltantes</strong
              >
            </div>
          </div>
          <div
            class="mb-5"
            :class="mobile ? 'px-5' : 'px-15 mt-13'"
            style="width:100%; display: flex; align-items: center;"
            :style="
              desktop
                ? 'flex-direction: row; justify-content: center;'
                : 'flex-direction: column; justify-content: center;'
            "
          >
            <v-btn
              rounded
              x-large
              class="white--text"
              style="background-color: #16C62E"
              :class="desktop ? 'mr-5' : 'mb-5'"
              @click="sendForm()"
            >
              Enviar
            </v-btn>
          </div>
        </div>
      </div>
      <span class="last-subtitle-404 my-4" :class="desktop ? 'mt-1' : 'mt-15'"
        >©2020 Tway</span
      >
    </div>
  </div>
</template>
<script scoped>
  import CompanyService from "@/services/companyService";

  export default {
    data() {
      return {
        form: {
          type: "client",
          name: "",
          lastname: "",
          company: "",
          sector: "",
          email: "",
          phone: "",
        },
        check: false,
        error: false,
        errorForm: false,
        formCheck: false,
        modalTerms: false,
        sent: false,
        firstTimePhone: true,
        emailRules: [
          (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@“]+(\.[^<>()[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (
              pattern.test(value) ||
              "Escribe un correo válido. Ej: nombre@empresa.com"
            );
          },
        ],
        phoneRules: [
          (value) => {
            const pattern = /\D*([+56][2-9])(\d{10})\D*/;
            return (
              (pattern.test(value) && value.length == 12) ||
              "Escribe un número válido. Ej: +56912345678"
            );
          },
        ],
      };
    },
    created() {
      if (this.$route.params.form != null) {
        this.formCheck = true;
      }
    },
    methods: {
      sendForm() {
        this.errorForm = false;
        if (
          this.form.type == "" ||
          this.form.name == "" ||
          this.form.lastname == "" ||
          this.form.company == "" ||
          this.form.sector == "" ||
          this.form.email == "" ||
          this.form.phone == ""
        ) {
          this.errorForm = true;
          return;
        }
        const patternEmail = /^(([^<>()[\]\\.,;:\s@“]+(\.[^<>()[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const patternPhone = /\D*([+56][2-9])(\d{10})\D*/;
        if (
          this.check &&
          patternEmail.test(this.form.email) &&
          patternPhone.test(this.form.phone) &&
          this.form.phone.length == 12
        ) {
          CompanyService.subscribe(this.form)
            .then(() => {
              this.sent = true;
              this.formCheck = false;
            })
            .catch((this.error = true));
        }
      },
    },
    watch: {
      "form.phone"() {
        if (this.form.phone != "") {
          this.firstTimePhone = false;
        }
      },
    },
    computed: {
      year() {
        return new Date().getFullYear();
      },
      phoneCheck() {
        const pattern = /\D*([+56][2-9])(\d{10})\D*/;
        if (this.form.phone.length == 0 && this.firstTimePhone) {
          return true;
        }
        if (this.form.phone.length == 12 && pattern.test(this.form.phone)) {
          return true;
        }
        return false;
      },
      mobile() {
        return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
      },
      desktop() {
        return (
          this.$vuetify.breakpoint.md ||
          this.$vuetify.breakpoint.lg ||
          this.$vuetify.breakpoint.xl
        );
      },
    },
  };
</script>
<style lang="scss" scoped>
  .parent-container-404 {
    background-color: #4a148c;
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container-404 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    height: 100%;
  }

  .app-combobox.error--text,
  .app-combobox .error--text {
    color: white !important;
    caret-color: white !important;
  }

  .title-404 {
    font-family: Josefin Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 50px;
    /* identical to box height, or 125% */

    /* shades / white */

    color: #ffffff;
  }

  .title-404-mobile {
    font-family: Josefin Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    /* or 117% */

    text-align: center;

    /* shades / white */

    color: #ffffff;
  }

  .v-messages__message {
    color: rgb(0, 0, 0) !important;
    caret-color: rgb(2, 0, 0) !important;
  }

  .scrollable {
    height: 350px;
    overflow-y: scroll;
  }

  .subtitle-404 {
    font-family: Josefin Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 30px;
    /* or 136% */

    /* shades / white */

    color: #ffffff;
  }

  .absolute-404 {
    position: absolute;
    width: 91px;
    height: 25px;
    left: calc(50% - 91px / 2 - 0.5px);
    top: calc(90% - 25px / 2 + 2.5px);
  }

  .last-subtitle-404 {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    /* identical to box height, or 139% */

    text-align: right;

    /* shades / white */

    color: #ffffff;
  }

  .subtitle-404-mobile {
    font-family: Josefin Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    /* or 160% */
    display: flex;

    text-align: center;

    /* shades / white */

    color: #ffffff;
  }

  .button-404 {
    background-color: #7319d5 !important;
  }
</style>
